import React from "react";
import "./QuizNav.css";
import { useNavigate } from "react-router-dom";

function QuizNav() {
  // Navigation for buttons
  const navigate = useNavigate();

  // handling the logout button
  const handleLogout = () => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.message);
        navigate(`/`);
      })
      .catch((error) => console.error("Error logging out:", error));
  };

  return (
    <div className="quiz-nav-container">
      <header className="dash-header">
        <button onClick={() => navigate(`/dashboard`)}>Dashboard</button>
        <button onClick={handleLogout}>Log Out</button>
      </header>

      <h2>Select a quiz from below</h2>

      <div className="quiz">
        <button
          onClick={() => navigate(`/quiz`, { state: { type: "practitioner" } })}
        >
          Practitioner to Practitioner Quiz
        </button>
        <button onClick={() => navigate(`/quiz`, { state: { type: "user" } })}>
          Practitioner to User Quiz
        </button>
                <button onClick={() => navigate(`/quiz/personality`)}>
          Personality Quiz
        </button>
      </div>
    </div>
  );
}

export default QuizNav;
